var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home-reporting-kpis px-2 pb-2 w-full" },
    [
      _c(
        "b-card",
        {
          staticClass: "mb-0 shadow-none border home-reporting-kpis__card",
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function() {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-wrap align-items-center justify-content-between w-100 gap-2"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center flex-wrap" },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-50 text-primary",
                            attrs: { icon: "BarChartIcon", size: "20" }
                          }),
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v("Formulário de Relato")
                          ]),
                          _c(
                            "b-badge",
                            {
                              staticClass: "ml-1",
                              attrs: { variant: "light-secondary" }
                            },
                            [_vm._v("Últimos 15 dias")]
                          )
                        ],
                        1
                      ),
                      _vm.canViewReportingDashboardData &&
                      _vm.$acl.hasPermission(
                        "reporting_channel_handling.dashboard.menu"
                      )
                        ? _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "flat-primary",
                                size: "sm",
                                to: {
                                  name: "reporting_channel_dashboard_index"
                                }
                              }
                            },
                            [
                              _vm._v(" Dashboard completo "),
                              _c("feather-icon", {
                                staticClass: "ml-25",
                                attrs: { icon: "ChevronRightIcon", size: "14" }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm.canViewReportingDashboardData
            ? _c(
                "b-card-body",
                { staticClass: "pt-2" },
                [
                  _vm.loading
                    ? _c(
                        "div",
                        { staticClass: "text-center py-3 text-muted" },
                        [_vm._v(" Carregando indicadores… ")]
                      )
                    : [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-wrap align-items-center justify-content-between mb-3 gap-2"
                          },
                          [
                            _c("small", { staticClass: "text-muted mb-0" }, [
                              _vm._v(
                                " Duas visões disponíveis; a última escolha fica salva neste navegador. "
                              )
                            ]),
                            _c(
                              "b-button-group",
                              {
                                staticClass: "home-reporting-kpis__toggle",
                                attrs: { size: "sm" }
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      variant:
                                        _vm.viewMode === "general"
                                          ? "primary"
                                          : "outline-primary"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.setViewMode("general")
                                      }
                                    }
                                  },
                                  [_vm._v(" Visão geral ")]
                                ),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      variant:
                                        _vm.viewMode === "all"
                                          ? "primary"
                                          : "outline-primary"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.setViewMode("all")
                                      }
                                    }
                                  },
                                  [_vm._v(" Visão por indicadores ")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        !_vm.hasAnyData
                          ? _c(
                              "b-alert",
                              {
                                staticClass: "mb-0 text-center",
                                attrs: { show: "", variant: "light" }
                              },
                              [_vm._v(" Não há dados no período para exibir. ")]
                            )
                          : _vm.viewMode === "general"
                          ? _c(
                              "div",
                              { staticClass: "home-reporting-kpis--general" },
                              [
                                _c(
                                  "b-row",
                                  { staticClass: "align-items-center" },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass:
                                          "text-center text-md-left py-3 py-md-0",
                                        attrs: { cols: "12", md: "4" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "display-4 text-primary font-weight-bold mb-0"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.totalStatus) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "text-muted small mt-1"
                                          },
                                          [
                                            _vm._v(
                                              " Situação (tratamento) no período "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-muted small mt-2 d-none d-md-block"
                                          },
                                          [
                                            _vm._v(" Distribuição por "),
                                            _c("strong", [
                                              _vm._v("Situação (tratamento)")
                                            ]),
                                            _vm._v(". ")
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "12", md: "8" } },
                                      [
                                        _vm.statusChartSeries.length
                                          ? [
                                              _c("vue-apex-charts", {
                                                attrs: {
                                                  type: "donut",
                                                  height: "300",
                                                  options:
                                                    _vm.statusHomeOptions,
                                                  series: _vm.statusChartSeries
                                                }
                                              })
                                            ]
                                          : _c(
                                              "b-alert",
                                              {
                                                staticClass: "mb-0 small",
                                                attrs: {
                                                  show: "",
                                                  variant: "info"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " Não há situação de tratamento classificada para montar o gráfico. "
                                                )
                                              ]
                                            )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _c(
                              "div",
                              { staticClass: "home-reporting-kpis--all" },
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-3",
                                        attrs: { cols: "12", md: "6" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "small font-weight-bold text-uppercase text-muted mb-1"
                                          },
                                          [_vm._v(" Nível de criticidade ")]
                                        ),
                                        _vm.chartSeries.length
                                          ? [
                                              _c("vue-apex-charts", {
                                                attrs: {
                                                  type: "donut",
                                                  height: "240",
                                                  options:
                                                    _vm.severityHomeOptions,
                                                  series: _vm.chartSeries
                                                }
                                              })
                                            ]
                                          : _c(
                                              "b-alert",
                                              {
                                                staticClass: "mb-0 py-2 small",
                                                attrs: {
                                                  show: "",
                                                  variant: "light"
                                                }
                                              },
                                              [_vm._v("Sem dados")]
                                            )
                                      ],
                                      2
                                    ),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-3",
                                        attrs: { cols: "12", md: "6" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "small font-weight-bold text-uppercase text-muted mb-1"
                                          },
                                          [_vm._v(" Situação (tratamento) ")]
                                        ),
                                        _vm.statusChartSeries.length
                                          ? [
                                              _c("vue-apex-charts", {
                                                attrs: {
                                                  type: "donut",
                                                  height: "240",
                                                  options:
                                                    _vm.statusHomeOptions,
                                                  series: _vm.statusChartSeries
                                                }
                                              })
                                            ]
                                          : _c(
                                              "b-alert",
                                              {
                                                staticClass: "mb-0 py-2 small",
                                                attrs: {
                                                  show: "",
                                                  variant: "light"
                                                }
                                              },
                                              [_vm._v("Sem dados")]
                                            )
                                      ],
                                      2
                                    ),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-3",
                                        attrs: { cols: "12", md: "6" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "small font-weight-bold text-uppercase text-muted mb-1"
                                          },
                                          [_vm._v(" Tipo de relato ")]
                                        ),
                                        _vm.typeReportingChartSeries.length
                                          ? [
                                              _c("vue-apex-charts", {
                                                attrs: {
                                                  type: "donut",
                                                  height: "240",
                                                  options:
                                                    _vm.typeReportingHomeOptions,
                                                  series:
                                                    _vm.typeReportingChartSeries
                                                }
                                              })
                                            ]
                                          : _c(
                                              "b-alert",
                                              {
                                                staticClass: "mb-0 py-2 small",
                                                attrs: {
                                                  show: "",
                                                  variant: "light"
                                                }
                                              },
                                              [_vm._v("Sem dados")]
                                            )
                                      ],
                                      2
                                    ),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-3",
                                        attrs: { cols: "12", md: "6" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "small font-weight-bold text-uppercase text-muted mb-1"
                                          },
                                          [_vm._v(" Identificação ")]
                                        ),
                                        _vm.identificationChartSeries.length
                                          ? [
                                              _c("vue-apex-charts", {
                                                attrs: {
                                                  type: "donut",
                                                  height: "240",
                                                  options:
                                                    _vm.identificationHomeOptions,
                                                  series:
                                                    _vm.identificationChartSeries
                                                }
                                              })
                                            ]
                                          : _c(
                                              "b-alert",
                                              {
                                                staticClass: "mb-0 py-2 small",
                                                attrs: {
                                                  show: "",
                                                  variant: "light"
                                                }
                                              },
                                              [_vm._v("Sem dados")]
                                            )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                      ]
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }